import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ErrorModels, Tarif } from '@wz-models';
import { InteractionService, LoggerService } from '@wz-services';
import { formatDate, getDateUtc } from '@wz-utilities/date.utilities';
import * as CryptoJS from 'crypto-js';
import { addDays } from 'date-fns';
import { SouscriptionEnLigneApiService } from 'libs/modules/tunnelsante/services/api/souscription-en-ligne-api.service';
import { TextGarantieModelZenioo } from 'models/text-garantie-model-zenioo.model';
import { TextGarantieMtxVita } from 'models/text-garantie-mtx-vita.model';
import { TexteGarantiesModels } from 'models/texte-garanties.models';
import { Enfant } from '../../insurances/devis-formulaire/Models/Enfant';
import { NiveauRemboursement } from '../../insurances/devis-formulaire/Models/NiveauRemboursement';
import { Personne } from '../../insurances/devis-formulaire/Models/Personne';
import { TaggingService } from '../../insurances/services/tagging.service';
import { ErrorFraudeModalService } from '../error-fraude-modal/error-fraude-modal.service';
import { Assurees } from '../models/Assurees.model';
import { Paiement } from '../models/Paiement.model';
import { Souscription } from '../models/Souscription.model';
import {
  DisplayValues,
  TarifContrat,
  TarifViewModel,
  ValueSubscribe,
} from '../models/tarif-view-model.model';
import { OriginThemeService } from '../originThemeService';
import { Guid_Mdp } from '../souscription-en-ligne/souscription-en-ligne.component';
@Component({
  selector: 'wz-souscription-contrat-formule',
  templateUrl: './souscription-contrat-formule.component.html',
  styleUrls: ['./souscription-contrat-formule.component.scss'],
  standalone: false,
})
export class SouscriptionContratFormuleComponent implements OnInit {
  errorFraude: boolean = false;
  DateNaissanceMin!: Date;
  formatDateDebutContrat!: string | null;
  healthEffectDateMin!: Date;
  formatDateEffetMin!: string | null;
  dateEffetMax!: Date;
  formatDateEffetMax!: string | null;
  public personne!: Personne;
  public tarif!: Tarif | any;
  tarifContrat: TarifContrat[] = [];
  responseTarif!: Tarif[];
  enfant: Enfant = new Enfant(0, []);
  niveauRemboursement: NiveauRemboursement = new NiveauRemboursement(
    '',
    '',
    '',
    '',
    '',
  );

  @Output() validerEvent = new EventEmitter();
  @Input() valueSouscription!: ValueSubscribe;
  @Input() selectedIndex: number = 0;
  filesTypeProduct!: string;
  pathCGProduct!: string;
  pathFidProduct!: string;
  pathTabProduct!: string;
  pathDoc: string = 'assets/doc/';
  root: string = 'http://afisante.prod2013.afiassurances.fr/docs/';
  paiement!: Paiement;
  souscription!: Souscription;
  tarifViewModel!: TarifViewModel | any;
  assurees!: Assurees;
  nomEtablissement: string = '';
  iban: string = '';
  bic: string = '';
  ibanMask: any = '[a-zA-Z0-9]{4}[ ]';
  modePaiement: string = '';
  date35: Date = new Date();
  @Input() GUID: string = '';
  @Input() MDP: string = '';
  guid_mdp!: Guid_Mdp;
  @Input() testMsg: string = '';
  @Output() eventEmitterContrat: EventEmitter<any> = new EventEmitter<any>();

  //Tagging
  VisiteurId!: string;
  lead_temp: any;

  @ViewChild('justitifatif', { static: false })
  justitifatifElemenet!: ElementRef<HTMLParagraphElement>;
  isMobile: boolean = false;
  loading: boolean = false;

  constructor(
    private souscriptionApi: SouscriptionEnLigneApiService,
    private interactionService: InteractionService,
    private taggingService: TaggingService,
    private originThemeService: OriginThemeService,
    //private router : Router,
    public errorDialogService: ErrorFraudeModalService,
    private loggerService: LoggerService,
  ) {
    let query = window.matchMedia('only screen and (max-width: 750px)');
    let $this = this;

    query.addListener((query) => {
      if (query.matches) {
        $this.isMobile = true;
      } else {
        $this.isMobile = false;
      }
    });
  }

  ibanValid: boolean = false;
  msgError: string = '';
  datePrelevement: string = '10'; //10 ou 15
  fractionnement: string = 'mensuel'; //ou annuel
  // franctionnement: number = 0; //ou mensuel/annuel
  // datePrelevement1: number = 0; // 10 / 15
  documentAdhesion!: string;
  rythmePrelevement: string = 'mensuel'; //ou annuel
  loiMadelin: boolean = false;
  aDejaContrat: string = '0';
  depuisPlusUnAn: string = '0';
  // aDejaContrat: boolean = false;
  // depuisPlusUnAn: boolean = false;

  ngOnInit() {
    this.themeParams();

    const responseTarif = sessionStorage.getItem('liste.listeTarif');
    if (responseTarif) {
      this.responseTarif = JSON.parse(responseTarif);
    }
    let dateDuJour = new Date();
    this.personne = new Personne(
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      this.enfant,
      '',
      this.niveauRemboursement,
      '',
      '',
      '',
      false,
      localStorage.getItem('parrain') || '',
    );
    const value = sessionStorage.getItem('app.personne');
    if (value) {
      this.personne = JSON.parse(value);
    }
    const valueTarif = sessionStorage.getItem('app.produittarif');
    if (valueTarif) {
      this.tarif = JSON.parse(valueTarif);
    }

    const lead = sessionStorage.getItem('app.lead');
    if (lead) {
      this.lead_temp = JSON.parse(lead);
    } else this.lead_temp = 'comparateurs';

    // this.valueSub = this.valueSouscrire.subscribe.nomSouscripteur;
    this.date35.setDate(this.date35.getDate() + 35);

    this.healthEffectDateMin = this.getHealthEffectDateMin();
    this.formatDateEffetMin = formatDate(
      this.healthEffectDateMin,
      'yyyy-MM-dd',
    );
    this.dateEffetMax = dateDuJour;
    this.dateEffetMax.setDate(dateDuJour.getDate() + 365);
    this.formatDateEffetMax = formatDate(this.dateEffetMax, 'yyyy-MM-dd');
    this.formatDateDebutContrat = formatDate(
      new Date(this.personne.dateDebutContrat),
      'dd/MM/yyyy',
    );
    this.Initialise();
    this.souscriptionApi.getFicheAdhesionPaiement();

    //Tagging
    this.VisiteurId = this.taggingService.checkVisiteurId();
    //if Zenio, date par defaut = 5
    if (
      this.tarif &&
      (this.tarif.produitTarif == 'ZEN_SANTE_SENIOR_ECO' ||
        this.tarif.produitTarif == 'ZEN_SANTE_SENIOR' ||
        this.tarif.produitTarif == 'ZEN_SANTE_55_PLUS' ||
        this.tarif.produitTarif == 'ZEN_SANTE_FAMILLE')
    ) {
      this.datePrelevement = '5';
    }
  }

  ngOnChanges(): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    // this.souscriptionApi.getAdhesionDocument();
    // this.validerContrat();
    const souscription = sessionStorage.getItem('save.souscription');
    if (souscription) {
      this.souscription = JSON.parse(souscription);
    }
    const assures = sessionStorage.getItem('save.assuree');
    if (assures) {
      this.assurees = JSON.parse(assures);
    }
    let tarif!: Tarif;
    const valueTarif = sessionStorage.getItem('app.produittarif');
    if (valueTarif) {
      tarif = JSON.parse(valueTarif);
    }
    // Tagging
    if (
      window['tc_vars'] &&
      window['tC'] &&
      this.VisiteurId != undefined &&
      this.selectedIndex == 1
    ) {
      let sha256Mail = '';

      sha256Mail = CryptoJS.SHA256(this.personne.email).toString(
        CryptoJS.enc.Hex,
      );

      this.taggingService.refreshSouscription(
        '2',
        'votre contrat et formule',
        this.VisiteurId,
        sha256Mail,
        this.lead_temp,
        tarif,
      );
    }
  }
  Initialise() {
    //this.souscriptionApi.SiteSouscrire(this.guid_mdp);
    this.guid_mdp = {
      guid: this.GUID,
      mdp: this.MDP,
    };
    this.loggerService.log(this.testMsg);
  }
  private getHealthEffectDateMin(): Date {
    return addDays(getDateUtc(), 1);
  }
  ate(a: string) {
    a = a.replace(',', '.');
    let r: number = +a;
    return r;
  }

  replaceFormule(f: string, tarif: string) {
    if (tarif == 'ZEN_SANTE_SENIOR' || tarif == 'ZEN_SANTE_SENIOR_ECO') {
      if (f == 'MO-11-10-10') {
        return 'Formule HOSPI';
      } else {
        f = f.split('-', 4)[2];
        f = f.substring(0, 1);
        return 'Formule ' + (Number(f) - 1);
      }
    }
    if (tarif == 'ZEN_SANTE_55_PLUS' || tarif == 'ZEN_SANTE_FAMILLE') {
      f = f.split('-', 4)[2];
      f = f.substring(0, 1);
      return 'Formule ' + f;
    } else {
      let a = Array.from(f.trim());
      return 'Formule ' + a[a.length - 1];
    }
  }

  enableLoading() {
    this.loading = true;
    (document.body as any).style.cursor = 'wait';
  }

  desableLoading() {
    this.loading = false;
    (document.body as any).style.cursor = 'auto';
  }

  //Passer à l'étape suivante:
  async validerContrat() {
    this.enableLoading();
    if (this.isIBANValid() == true) {
      const responseTarif = sessionStorage.getItem('liste.listeTarif');
      if (responseTarif) {
        this.responseTarif = JSON.parse(responseTarif);
      }
      const souscription = sessionStorage.getItem('save.souscription');
      if (souscription) {
        this.souscription = JSON.parse(souscription);
      }
      const assures = sessionStorage.getItem('save.assuree');
      if (assures) {
        this.assurees = JSON.parse(assures);
      }
      this.tarifViewModel = new TarifViewModel(
        this.valueSouscription.assures,
        this.valueSouscription.subscribe,
        this.responseTarif,
        this.tarif.produitTarif,
        this.tarif.codeFormule,
        '',
        '',
        '',
        '',
        '',
        this.tarif.codeFormule,
        true,
        true,
        true,
        new Date(),
        '',
        '',
        true,
        true,
        '',
        '',
        this.valueSouscription.subscribe.nomSouscripteur,
        this.valueSouscription.subscribe.adresseSouscripteur,
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
      );
      // this.loggerService.log(JSON.stringify(this.paiement));

      if (!this.tarifViewModel.assures.isConjoint) {
        this.tarifViewModel.assures.assureConjoint = null;
      }

      //Set Value on Paiement Model
      this.paiement = new Paiement(
        'Prelevement',
        10,
        10,
        this.sexeConverter(this.personne.sexe),
        this.personne.nom,
        this.personne.prenom,
        this.valueSouscription.subscribe.adresseSouscripteur,
        this.valueSouscription.subscribe.adresseComplementSouscripteur,
        this.valueSouscription.subscribe.codePostalSouscripteur,
        this.valueSouscription.subscribe.ville,
        '',
        '',
        '',
        this.personne.telephone,
        this.personne.email,
      );
      this.paiement.bic = this.bic;
      this.paiement.iban = this.iban;
      this.paiement.nomEtablissement = this.nomEtablissement;
      if (this.fractionnement == 'mensuel') {
        this.paiement.fractionnement = 1;
      }
      if (this.fractionnement == 'annuel') {
        this.paiement.fractionnement = 4;
      }
      this.tarifViewModel.LoiMadelin = this.loiMadelin;
      if (this.aDejaContrat == '0') {
        this.tarifViewModel.NoAncienneCompagnie = false;
      }
      if (this.aDejaContrat == '1') {
        this.tarifViewModel.NoAncienneCompagnie = true;
      }
      if (this.depuisPlusUnAn == '0') {
        this.tarifViewModel.NoCompagnie = false;
      }
      if (this.depuisPlusUnAn == '1') {
        this.tarifViewModel.NoCompagnie = true;
      }
      this.paiement.datePrelevement = parseInt(this.datePrelevement);

      await this.setFicheAdhesionTarif();
      var e = await this.setFicheAdhesionPaiement();
      if (e && e.statusCodeFraude === 406) {
        this.errorDialogService.openDialog('Erreur interne'); // Ouvre la modale
        // this.router.navigate(['/demande-devis']);
        // this.errorFraude = true;
        this.desableLoading();
        // sessionStorage.removeItem('app.personne');
        // sessionStorage.removeItem('tokenData');
        // localStorage.removeItem('data.client.personne');
        return;
      }
      this.desableLoading();

      if (this.errorFraude) return;
      //this.getFicheAdhesionTarif();
      //this.getFicheAdhesionPaiement();
      sessionStorage.setItem(
        'save.adhesiontarifviewmodel',
        JSON.stringify(this.tarifViewModel),
      );
      sessionStorage.setItem(
        'save.adhesionPaiement',
        JSON.stringify(this.paiement),
      );

      let valueDisplay: DisplayValues = {
        subscribe: this.souscription,
        paiement: this.paiement,
        tarifViewModel: this.tarifViewModel,
        assurees: this.assurees,
      };

      sessionStorage.setItem('save.valueDisplay', JSON.stringify(valueDisplay));
      this.eventEmitterContrat.emit(valueDisplay);
      ///Go to next Tab//
      if (this.selectedIndex < 3) {
        this.selectedIndex += 1;
        //Send the selected index to the parent component
        this.validerEvent.emit(this.selectedIndex);
      }
    } else {
      this.msgError = 'Veuiller renseigner un IBAN valide';
    }

    this.desableLoading();
  }
  getFicheAdhesionTarif() {
    this.souscriptionApi.getFicheAdhesionTarif().subscribe(
      (getAdhesiontarif) => {
        if (getAdhesiontarif != null) {
          this.loggerService.log(
            "get de fiche d'adhesion bien récupéré: " + getAdhesiontarif,
          );
        }
      },
      (err: ErrorModels.TunnelSanteError) => {
        this.interactionService.showError(
          'Erreur get fiche adhesion tarif',
          err.appMessage,
        );
      },
    );
  }
  getFicheAdhesionPaiement() {
    this.souscriptionApi.getFicheAdhesionPaiement().subscribe(
      (succes) => {
        this.interactionService.showSuccess(
          'Fiche paiement',
          'Success register in adhesion paiement',
        );
      },
      (err: ErrorModels.TunnelSanteError) => {
        this.interactionService.showError(
          'Probleme de get fiche adhesion paiement',
          err.appMessage,
        );
      },
    );
  }
  async setFicheAdhesionTarif() {
    await this.souscriptionApi
      .SetFicheAdhesionTarif(this.tarifViewModel)
      .toPromise()
      .then((response) => response)
      .catch((error) => console.error(error));
  }
  async setFicheAdhesionPaiement() {
    return await this.souscriptionApi
      .SetFicheAdhesionPaiement(this.paiement)
      .toPromise();
  }
  retour() {
    if (this.selectedIndex > -1) {
      this.selectedIndex -= 1;
      //Send the selected index to the parent component
      this.validerEvent.emit(this.selectedIndex);
    }
  }

  texteGaranties(produit: any) {
    let p: string = '';
    switch (produit) {
      case TexteGarantiesModels.TypeProduitsExistant
        .PrevoirImmediatSanteFamilleEco:
      case TexteGarantiesModels.TypeProduitsExistant
        .PrevoirImmediatSanteFamille:
      case TexteGarantiesModels.TypeProduitsExistant
        .AESIOImmediatSanteFamilleEco:
      case TexteGarantiesModels.TypeProduitsExistant.AESIOImmediatSanteFamille:
        p = 'PREVOIR_IMMEDIAT_100_SANTE_FAMILLE.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant
        .PrevoirImmediatSanteSeniorEco:
      case TexteGarantiesModels.TypeProduitsExistant
        .AESIOImmediatSanteSeniorEco:
      case TexteGarantiesModels.TypeProduitsExistant.AESIOImmediatSanteSenior:
        p = 'PREVOIR_IMMEDIAT_100_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.PrevoirImmediatSanteSenior:
        p = 'PREVOIR_IMMEDIAT_100_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.Relaxeo2:
        p = 'Relaxeo2.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.Vitaneor3:
        p = 'Vitaneor3.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.Essentiel2:
        p = 'Essentiel2.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.EssentielSanteFamille:
        p = 'ESSENTIEL_SANTE_FAMILLE.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.EssentielSanteSenior:
        p = 'ESSENTIEL_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.SwissLifeParticulier:
        p = 'SWISSLIFE_SANTE_PARTICULIER.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.SwissLifeRetraite:
        p = 'SWISSLIFE_SANTE_RETRAITE.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.ProgressionSanteFamille:
        p = 'PROGR_SANTE_FAMILLE.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.ProgressionSanteSenior:
        p = 'PROGR_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteSenior:
        p = 'ZENIOO_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteFamille:
        p = 'ZENIOO_SANTE_INTEGRALE_FAMILLE.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteSeniorEco:
        p = 'ZENIOO_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteCCPlus:
        p = 'ZENIOO_SANTE_INTEGRALE_PLUS.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.Optimum:
      case 'MTX_OPTIMUM_SANTE':
        p = 'Optimum.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieMtxVita.TypeProduitsExistant.MtxVitaFamilleNr:
        p = 'MTX_VITA_SANTE_FAMILLE_NR.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieMtxVita.TypeProduitsExistant.MtxVitaPlus55Nr:
        p = 'MTX_VITA_SANTE_55PLUS_NR.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      default:
        break;
    }
  }
  noticeInformation(produit: any) {
    let p: string = '';
    switch (produit) {
      case TexteGarantiesModels.TypeProduitsExistant
        .PrevoirImmediatSanteFamilleEco:
      case TexteGarantiesModels.TypeProduitsExistant
        .PrevoirImmediatSanteFamille:
      case TexteGarantiesModels.TypeProduitsExistant
        .AESIOImmediatSanteFamilleEco:
      case TexteGarantiesModels.TypeProduitsExistant.AESIOImmediatSanteFamille:
        p = 'PREVOIR_IMMEDIAT_100_SANTE_FAMILLE.pdf';
        this.pathCGProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathCGProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant
        .PrevoirImmediatSanteSeniorEco:
      case TexteGarantiesModels.TypeProduitsExistant
        .AESIOImmediatSanteSeniorEco:
      case TexteGarantiesModels.TypeProduitsExistant.AESIOImmediatSanteSenior:
        p = 'PREVOIR_IMMEDIAT_100_SANTE_SENIOR.pdf';
        this.pathCGProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathCGProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.PrevoirImmediatSanteSenior:
        p = 'PREVOIR_IMMEDIAT_100_SANTE_SENIOR.pdf';
        this.pathCGProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathCGProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.Relaxeo2:
        p = 'Relaxeo2.pdf';
        this.pathCGProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathCGProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.Vitaneor3:
        p = 'Vitaneor3.pdf';
        this.pathCGProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathCGProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.Essentiel2:
        p = 'Essentiel2.pdf';
        this.pathCGProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathCGProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.EssentielSanteFamille:
        p = 'ESSENTIEL_SANTE_FAMILLE.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.EssentielSanteSenior:
        p = 'ESSENTIEL_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.SwissLifeParticulier:
        p = 'SWISSLIFE_SANTE_PARTICULIER.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.SwissLifeRetraite:
        p = 'SWISSLIFE_SANTE_RETRAITE.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.ProgressionSanteFamille:
        p = 'PROGR_SANTE_FAMILLE.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.ProgressionSanteSenior:
        p = 'PROGR_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteSenior:
        p = 'ZENIOO_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteFamille:
        p = 'ZENIOO_SANTE_INTEGRALE_FAMILLE.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteSeniorEco:
        p = 'ZENIOO_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteCCPlus:
        p = 'ZENIOO_SANTE_INTEGRALE_PLUS.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.Optimum:
      case 'MTX_OPTIMUM_SANTE':
        p = 'Optimum.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieMtxVita.TypeProduitsExistant.MtxVitaFamilleNr:
        p = 'MTX_VITA_SANTE_FAMILLE_NR.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieMtxVita.TypeProduitsExistant.MtxVitaPlus55Nr:
        p = 'MTX_VITA_SANTE_55PLUS_NR.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      default:
        break;
    }
  }

  //Verification IBAN:
  isIBANValid() {
    return true;
    // var ibanCode = this.numeroInseeService.VerifierIBAN(this.iban);
    // if (ibanCode) {
    //     this.ibanValid = true;
    //     return true;
    // } else
    //     this.ibanValid = false;
    // return false;
  }

  sexeConverter(sexeNumber: string): any {
    switch (sexeNumber) {
      case '1':
        return 'madame';
      case '2':
        return 'monsieur';
    }
  }

  showJustificatif(event: any) {
    let el = this.justitifatifElemenet.nativeElement;
    el.classList.remove('hide');
    el.classList.remove('show');
    el.classList.add('show');
  }
  showJustificatifMobile(event: any) {
    event.preventDefault();
    let el = this.justitifatifElemenet.nativeElement;
    el.classList.remove('hide');
    el.classList.remove('show');
    el.classList.add('show');
  }

  hideJustificatif(event: any) {
    let el = this.justitifatifElemenet.nativeElement;
    el.classList.remove('hide');
    el.classList.remove('show');
    el.classList.add('hide');
  }

  onInputChange() {
    let value = this.iban;
    // Remove all non-alphanumeric characters
    value = value
      .replace(/\W/gi, '')
      .replace(/(.{4})/g, '$1 ')
      .trim();
    this.iban = value;
  }

  // Origine theme
  origine!: string;
  originTheme!: any;

  btn_bg = 'linear-gradient(231.74deg, #FF6713 -26.89%, #FF9B00 64.63%)';
  btn_bg_simple = '#FF9600';
  btn_border_simple = '2px solid #FF9600';
  bg_justification = '#ff950034';
  c_ratio_theme: string = 'orange';
  donate_theme = 'th_default';
  choixRadio_theme = 'th_default';

  themeParams() {
    const origine: any = localStorage.getItem('codeOrigin');
    this.origine =
      origine && this.originThemeService.IsTrueOrigine(origine)
        ? origine
        : null;
    this.originTheme = this.originThemeService.GetTheme(this.origine, 2);
    if (this.origine) this.useTheme(this.originTheme);
  }

  useTheme(theme: any) {
    this.c_ratio_theme = theme.c_ratio_theme;
    this.btn_bg = theme.btn_bg;
    this.btn_bg_simple = theme.btn_bg_simple;
    this.btn_border_simple = theme.btn_border_simple;
    this.bg_justification = theme.bg_justification;
    this.donate_theme = theme.donate_theme;
    this.choixRadio_theme = this.donate_theme;
  }
}
